import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import type { Ref } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveTabHelpDocs } from '@/routes/tabHelpDocs';

type TabHelperProps = {
  innerRef?: Ref<HTMLAnchorElement>;
};

const TabHelper = ({ innerRef }: TabHelperProps) => {
  const { pathname } = useLocation();
  const helpUrl = resolveTabHelpDocs(pathname);

  if (!helpUrl) {
    return null;
  }

  return (
    <ChildrensTooltip html="راهنمای این صفحه">
      <a
        ref={innerRef}
        id="help-icon"
        href={helpUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link d-flex align-items-center pe-1"
      >
        <FontAwesomeIcon icon="question-circle" className="fs-1" />
      </a>
    </ChildrensTooltip>
  );
};

export default TabHelper;
